<template>
  <jet-dialog-modal :show="show" @close="close" max-width="5xl">
    <template #title>
      <div class="flex justify-between items-center pr-4">
        <span>{{ title || fileName || 'File Preview' }}</span>
      </div>
    </template>
    <template #content>
      <div class="w-full h-[80vh] border rounded overflow-hidden bg-gray-50 relative flex items-center justify-center">
        <iframe v-if="isPdf" :src="fileUrl" class="w-full h-full" frameborder="0"></iframe>
        <img v-else-if="isImage" :src="fileUrl" class="max-w-full max-h-full object-contain" />
        <div v-else class="text-gray-500">Preview not available for this file type.</div>
      </div>
    </template>
    <template #footer>
      <div class="flex justify-end">
        <jet-secondary-button @click="close">
          {{ $t("actions.close") || 'Close' }}
        </jet-secondary-button>
      </div>
    </template>
  </jet-dialog-modal>
</template>

<script>
import JetDialogModal from "@/Jetstream/DialogModal";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import { defineComponent } from "vue";

export default defineComponent({
  name: "FilePreviewModal",
  props: {
    show: Boolean,
    fileUrl: String,
    fileName: String,
    title: String
  },
  components: {
    JetDialogModal,
    JetSecondaryButton
  },
  emits: ['close'],
  computed: {
    isPdf() {
      return this.fileName?.toLowerCase().endsWith('.pdf') || this.fileUrl?.toLowerCase().includes('.pdf');
    },
    isImage() {
      const ext = this.fileName?.toLowerCase().split('.').pop() || this.fileUrl?.toLowerCase().split('.').pop()?.split('?')[0];
      return ['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp'].includes(ext);
    }
  },
  methods: {
    close() {
      this.$emit('close');
    }
  }
});
</script>
